import * as React from "react"

const RightIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48">
    <path d="M17.17 32.92l9.17-9.17-9.17-9.17L20 11.75l12 12-12 12z"></path>
  </svg>
)

export default RightIcon
